import { render, staticRenderFns } from "./SupportDiscussion.vue?vue&type=template&id=17c1cfa5&scoped=true"
import script from "./SupportDiscussion.vue?vue&type=script&lang=js"
export * from "./SupportDiscussion.vue?vue&type=script&lang=js"
import style0 from "./SupportDiscussion.vue?vue&type=style&index=0&id=17c1cfa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1cfa5",
  null
  
)

export default component.exports